import { DEV_API_URL, PROD_API_URL, STAGE_API_URL } from '@/lib/constants/api'
import { isDevelopment, isStage } from '@/lib/environment'

const getApiLocation = () => {
  if (isDevelopment()) {
    return DEV_API_URL
  }

  if (isStage()) {
    return STAGE_API_URL
  }

  return PROD_API_URL
}

export default getApiLocation
